module.exports = __webpack_public_path__ + "img/Ua1.dca5929e.png";